
import { FormPage } from "../../types/form";

export const page4Config: FormPage = {
  page: 4,
  elements: [
    {
      id: "section_teaching_materials",
      type: "section_header",
      label: "ข้อมูลการสอน"
    },
    {
      id: "worksheet_upload",
      type: "file",
      label: "อัปโหลดชีท",
      name: "worksheet_urls",
      required: false,
      description: "กรณีครูเตรียมชีทเองให้อัปโหลดชีทด้วยนะคะ",
      validation: {
        maxFiles: 1,
        maxSizeMB: 50
      }
    },
    {
      id: "worksheet_links",
      type: "document_link",
      label: "ชีทของหัวข้อนี้",
      name: "document_links",
      required: false,
      description: "ชีทที่มีอยู่สำหรับหัวข้อนี้"
    },
    {
      id: "drive_link",
      type: "url",
      label: "หากไม่สามารถดาวโหลดชีทได้ รบกวนโหลดใส่ Drive และคัดลอกลิงก์ใส่ตรงนี้นะคะ",
      name: "worksheet_drive_link",
      required: false
    },
    {
      id: "final_check_instruction",
      type: "instruction",
      text: "กรุณารีเช็กข้อมูลอีกครั้งก่อนกดส่ง *\nเมื่อกรอกข้อมูลมาแล้ว มีข้อผิดพลาด เช่น กรอกวันที่ผิด เรทค่าสอนผิด สะกดคำผิด ทางส่วนกลางมีโควต้าในการแก้ไข 3 ครั้ง/เดือน หากผิดเกินจากนี้ทางส่วนกลางจะไม่แก้ไขข้อมูลให้ ซึ่งจะส่งผลต่อการทำเงินเดือนของคุณครู ดังนั้นคุณครูจะต้องตรวจสอบข้อมูลให้ถี่ถ้วนก่อนกดส่งนะคะ\n*หมายเหตุ : 3 ครั้ง/ เดือน หมายถึง 1 คลาสที่ผิดจุดใดจุดหนึ่ง เช่น วันที่ผิด จะถือว่าแก้ไขแล้ว 1 ครั้ง"
    }
  ]
};
